import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiStripepaymentgatewayTransactionsSaveCardMutationRequest,
  PostApiStripepaymentgatewayTransactionsSaveCardMutationResponse,
  PostApiStripepaymentgatewayTransactionsSaveCard401,
  PostApiStripepaymentgatewayTransactionsSaveCard403,
} from "../../../types/PostApiStripepaymentgatewayTransactionsSaveCard";

export function getPostApiStripepaymentgatewayTransactionsSaveCardUrl() {
  return `/api/StripePaymentGateway/transactions/save-card` as const;
}

/**
 * {@link /api/StripePaymentGateway/transactions/save-card}
 */
export async function postApiStripepaymentgatewayTransactionsSaveCard(
  data?: PostApiStripepaymentgatewayTransactionsSaveCardMutationRequest,
  config: Partial<
    RequestConfig<PostApiStripepaymentgatewayTransactionsSaveCardMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiStripepaymentgatewayTransactionsSaveCardMutationResponse,
    ResponseErrorConfig<
      | PostApiStripepaymentgatewayTransactionsSaveCard401
      | PostApiStripepaymentgatewayTransactionsSaveCard403
    >,
    PostApiStripepaymentgatewayTransactionsSaveCardMutationRequest
  >({
    method: "POST",
    url: getPostApiStripepaymentgatewayTransactionsSaveCardUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
